import React from 'react';
import { Palette } from 'Palette';
import PropertyFilteredList from '../PropertyFilteredList';
import { StyledButton } from '../styles/StyledButtons';

interface PropertiesPendingProps {
  onItemClick?: (link: string) => void;
  wrapperClassName?: string;
  tone?: keyof typeof Palette;
  propertyCardTone?: keyof typeof Palette;
  noSpacing?: boolean;
  onAddClicked: () => void;
}

export default class PropertiesPending extends React.Component<PropertiesPendingProps> {
  render() {
    return (
      <PropertyFilteredList
        filterStatus={['NEW', 'APPROVED']}
        title="New Opportunities"
        description="New Fund Opportunities that have not yet been released to potential investors"
        headerAction={
          <StyledButton
            noTopSpacing
            onClick={this.props.onAddClicked}
            variant="contained"
            color="primary"
          >
            Create Opportunity
          </StyledButton>
        }
        tone={this.props.tone}
        propertyCardTone={this.props.propertyCardTone}
        noSpacing={this.props.noSpacing}
        firstElement
        linkable={true}
      />
    );
  }
}
